import { formatHeightWidth } from './format-height-width'

// A playlist is sized by resolution, never bound to a display, so the Select stores
// "<pixelsH>,<pixelsW>". Listing one option per display made every display sharing a
// resolution produce the same option value, and Material-UI then labelled the field with
// the last matching option regardless of which one was clicked. One option per resolution
// removes the ambiguity.
const MAX_NAMES = 3

interface TDisplay {
  name: string
  pixelsH: number
  pixelsW: number
}

export interface TResolutionOption {
  value: string
  dimensions: string
  displayNames: string
}

export const groupDisplaysByResolution = (displays: TDisplay[]): TResolutionOption[] => {
  const byResolution = new Map<string, { dimensions: string; names: string[] }>()

  displays.forEach(({ name, pixelsH, pixelsW }) => {
    const value = pixelsH + ',' + pixelsW
    const option = byResolution.get(value)

    if (option) {
      option.names.push(name)
    } else {
      byResolution.set(value, {
        dimensions: formatHeightWidth({ height: pixelsH, width: pixelsW }),
        names: [name]
      })
    }
  })

  return Array.from(byResolution, ([value, { dimensions, names }]) => ({
    value,
    dimensions,
    // Longer lists are truncated by the option's CSS ellipsis.
    displayNames: names.slice(0, MAX_NAMES).join(', ')
  }))
}
